import { Link } from 'react-router-dom';
import { Check, ArrowRight } from 'lucide-react';

export default function OrderSuccessPage() {
  return (
    <div className="min-h-[calc(100vh-72px)] flex items-center justify-center px-6 py-16 bg-background" data-testid="order-success-page">
      <div className="text-center max-w-lg">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-full border border-gold text-gold mb-8">
          <Check className="w-6 h-6" strokeWidth={1.5} />
        </div>
        <div className="eyebrow mb-4">Confirmed</div>
        <h1 className="font-display font-light text-ink leading-[1.05] tracking-[-0.015em] mb-6" style={{ fontSize: 'clamp(40px, 5.5vw, 60px)' }}>
          Your order<br />is on its way.
        </h1>
        <p className="text-ink/75 mx-auto max-w-md" style={{ fontSize: 16, lineHeight: 1.7 }}>
          Your commission is pending our final review. We'll be in touch shortly with the estimated price, timeline, and next steps.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-12">
          <Link to="/orders" data-testid="view-orders-btn" className="inline-flex items-center justify-center gap-2 border border-ink text-ink hover:bg-ink hover:text-background uppercase tracking-luxe font-medium px-8 py-4 transition-all duration-300" style={{ fontSize: 13 }}>
            My Orders
          </Link>
          <Link to="/categories" data-testid="browse-more-btn" className="inline-flex items-center justify-center gap-2 border border-ink bg-ink text-background hover:bg-transparent hover:text-ink uppercase tracking-luxe font-medium px-8 py-4 transition-all duration-300" style={{ fontSize: 13 }}>
            Browse More <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </div>
  );
}
